import { useGetResourceLabel, useResourceContext } from 'react-admin';
import { makeStyles, Typography } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    height: 20,
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontSize: 22,
    fontWeight: 700,
    margin: '20px 0 0',
    '&::after': {
      height: 5,
      content: '""',
      display: 'block',
      flexGrow: 1,
      flexShrink: 1,
      marginLeft: 20,
      backgroundColor: theme.palette.primary.main
    }
  }
}));

export default function AdminTitle() {
  const resource = useResourceContext();
  const getResourceLabel = useGetResourceLabel();
  const classes = useStyles();

  if (!resource) {
    return null;
  }

  const label = getResourceLabel(resource);

  if (!label) {
    return null;
  }

  return (
    <Typography variant="h2" color="inherit" className={classes.root}>
      {label}
    </Typography>
  );
}
